import React from 'react';

const ButtonBasicSVG = ({ color, className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      className={className}
      onClick={onClick}
      {...props}
    >
      <rect width='40' height='40' rx='6' fill='#0957D0' />
    </svg>
  );
};

export default ButtonBasicSVG;
